export default {
    resetPin: 'รีเซ็ท รหัส PIN',
    pin: 'รหัส PIN',
    confirmPin: 'ยืนยันรหัส',
    save: 'บันทึก',
    incorrectPin: 'รหัสไม่ถูกต้อง',
    msgPinDontmatch: 'รหัสไม่ตรงกัน',
    congratulation: 'ยินดีด้วย',
    msgSaveSuccess: 'รหัส PIN ถูกอัปเดต'
}
